const firebaseConfig = {
    apiKey: "AIzaSyACXlUThCnIL6nmAEqslx7qsbW-JM0qK7Q",
    authDomain: "blog-mall.firebaseapp.com",
    projectId: "blog-mall",
    storageBucket: "blog-mall.appspot.com",
    messagingSenderId: "979442791977",
    appId: "1:979442791977:web:4a4f8acfcd5d73d0200e38"
};

export default firebaseConfig;